import { render, staticRenderFns } from "./Regisseure.vue?vue&type=template&id=f65c3b4a&"
import script from "./Regisseure.vue?vue&type=script&lang=js&"
export * from "./Regisseure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports